<template>
  <section>
    <loading-flux :value="loading"></loading-flux>
    <v-dialog
      v-model="modalAction"
      max-width="1300px"
      scrollable
      @keydown="executeCloseModalCreateRequestQuote"
      @click:outside="executeCloseModalCreateRequestQuote"
    >
      <v-card>
        <div class="p-4 pb-0">
          <h5>Agregar Solicitud de Cotización</h5>
        </div>
        <hr />
        <v-spacer></v-spacer>
        <v-card-text>
          <v-container>
            <v-data-table
              class="px-2 elevation-4 mt-5 pt-2"
              :headers="wrappedTableHeaders"
              :items="currentServices"
              :items-per-page="filters.items !== 'Todos' ? filters.items : 100"
              :page.sync="filters.page"
              hide-default-footer
              loading-text="Cargando Servicios"
              item-key="key"
              no-data-text="Sin Servicios"
              @page-count="pageCount = $event"
            >
              <template v-slot:item.quantity="{ item }">
                <v-text-field
                  type="number"
                  :min="1"
                  class="pt-0 mt-0"
                  v-model="item.quantity"
                  :hide-details="item.quantity < 1 ? false : true"
                  :error="item.quantity < 1"
                  :error-messages="item.quantity < 1 ? '1 unidad mínima' : null"
                ></v-text-field>
              </template>
              <template v-slot:item.name="{ item }">
                <v-text-field
                  :disabled="loading"
                  v-model="item.name"
                  outlined
                  single-line
                  dense
                  placeholder="Ingresa aqui el nombre del servicio.."
                  class="p-0 my-3"
                  hide-details
                ></v-text-field>
              </template>
              <template v-slot:item.actions="{ item }">
                <div class="d-flex justify-content-center">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="openModalFilesService(item)"
                        icon
                        small
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-badge
                          :content="
                            item.documents.length ? item.documents.length : '0'
                          "
                          color="success"
                          overlap
                        >
                          <v-icon> mdi-file-outline </v-icon>
                        </v-badge>
                      </v-btn>
                    </template>
                    <span> Documentos del Servicio </span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="openModalUpdateCommentService(item)"
                        icon
                        small
                        color="success"
                        v-bind="attrs"
                        v-on="on"
                        class="mx-2"
                      >
                        <v-badge
                          :content="item.comment ? 1 : '0'"
                          color="success"
                          overlap
                        >
                          <v-icon> mdi-comment-outline </v-icon>
                        </v-badge>
                      </v-btn>
                    </template>
                    <span> Comentarios del Servicio </span>
                  </v-tooltip>
                </div>
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="loading"
            color=""
            @click="executeCloseModalCreateRequestQuote"
          >
            <small> Cerrar </small>
          </v-btn>
          <v-btn
            :disabled="loading"
            color="primary"
            class="text-white"
            @click="createRequestQuote"
          >
            <small> Guardar </small>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <modal-files-service-quote
      :modalAction="dialogModalFilesService"
      :closeModalFilesService="closeModalFilesService"
      :currentService="currentService"
      :typeRequestService="REQUEST_SERVICE"
      @updateExchangeRateCurrentService="updateExchangeRateCurrentService"
    >
    </modal-files-service-quote>
    <modal-update-comment-service
      :modalAction="dialogModalUpdateCommentService"
      :closeModalUpdateCommentService="closeModalUpdateCommentService"
      :currentService="currentService"
    >
    </modal-update-comment-service>
  </section>
</template>

<script>
import swal2 from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import { authUsuarioComputed } from "@/state/helpers";
import {
  preventCloseIfNotKeyEventEsc,
  renameAndReturnNewFile,
} from "@/helpers/common";
import { REQUEST_SERVICE } from "@/constants/requestMaterial";
import ModalUpdateCommentService from "../../requestServices/components/ModalUpdateCommentService.vue";
import REQUEST_SERVICE_CONSTANTS from "@/constants/requestService";
import ModalFilesServiceQuote from "../components/quotes/ModalFilesServiceQuote.vue";
import QUOTE_CONSTANTS from "@/constants/quotes";
export default {
  props: {
    modalAction: {
      type: Boolean,
      default: false,
    },
    closeModalCreateRequestQuote: {
      type: Function,
      default: () => {},
    },
  },
  components: {
    ModalUpdateCommentService,
    ModalFilesServiceQuote,
  },
  data() {
    return {
      REQUEST_SERVICE,
      dialogModalFilesService: false,
      dialogModalUpdateCommentService: false,
      loading: false,
      currentServices: [
        {
          id:
            Math.random()
              .toString(36)
              .substring(2, 15) +
            Math.random()
              .toString(36)
              .substring(2, 15),
          quantity: 0,
          name: "",
          comment: null,
          documents: [],
        },
      ],
      currentService: null,
      filters: {
        page: 1,
        items: 50,
        filter: "",
      },
      tableHeaders: [
        {
          text: "Acción",
          align: "center",
          width: "5%",
          sortable: false,
          value: "actions",
        },
        {
          text: "Descripción",
          align: "start",
          sortable: false,
          value: "name",
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      sendCreateRequestQuote: "quote/createRequestQuote",
    }),
    updateExchangeRateCurrentService(itemExchangeRate) {
      this.currentService.documents = this.currentService.documents.map(
        (item) => {
          if (item.id == itemExchangeRate.id) {
            return itemExchangeRate;
          }
          return item;
        }
      );
    },
    async createRequestQuote() {
      if (this.currentServices.some((item) => !item.name)) {
        swal2.fire({
          icon: "error",
          title: "Error",
          text: "Todos los servicios deben tener una descripción",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 4000,
          timerProgressBar: true,
        });
        return;
      }
      if (
        this.currentServices.find((item) => {
          return REQUEST_SERVICE_CONSTANTS.ifServiceHasQuotedWithNoPriceOrSupplier(
            item
          );
        })
      ) {
        return swal2.fire({
          icon: "error",
          title: "Error",
          text:
            "Todas las cotizaciones adjuntas deben tener un precio y proveedor definidos",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 6000,
          timerProgressBar: true,
        });
      }
      this.loading = true;
      let existDocumentDuplicatesInService = false;
      let filesRequestService = [];

      let filesService = {};
      let currentService = this.currentServices[0];
      // Validar que el array de filesRequest no tenga documentos con el mismo nombre
      let filesRequestNames = currentService.documents.map(
        ({ file }) => file.name
      );
      let filesNameDuplicates = filesRequestNames.filter(
        (value, index, self) => {
          return self.indexOf(value) !== index;
        }
      );
      if (filesNameDuplicates.length > 0) {
        existDocumentDuplicatesInService = true;
      }
      currentService.documents.forEach((document, index) => {
        let filename = `${new Date().getTime() + index}_${document.file.name}`;
        let fileWithNewName = renameAndReturnNewFile(document.file, filename);
        filesRequestService.push(fileWithNewName);
        filesService[filename] = {
          comment: null,
          selected:
            REQUEST_SERVICE_CONSTANTS.getServiceQuotes(currentService).length ==
              1 &&
            document.category ==
              REQUEST_SERVICE_CONSTANTS.document_category_quotes
              ? true
              : document.selected
              ? true
              : false,
          supplier: document.supplier_rut
            ? document.supplier_rut.replaceAll(".", "")
            : null,
          type: REQUEST_SERVICE_CONSTANTS.getTypeDocumentFromFile(
            document,
            false
          ),
          unit_price: document.price
            ? Number(document.price.replaceAll(".", "").replaceAll(",", "."))
            : null,
          coin: document.coin || null,
          unique_supplier: false,
          tax_exempt: document.tax_exempt || false,
        };
      });

      let payload = {
        body: {
          user: this.user.email,
          title: `Cotización de ${this.user.email} por ${currentService.name}`,
          description: currentService.name,
          comment: currentService.comment,
          documents: filesService,
        },
        files: filesRequestService,
      };

      if (existDocumentDuplicatesInService) {
        this.loading = false;
        return swal2.fire({
          icon: "error",
          title: "Error",
          text: `Los documentos adjuntos en cada servicio deben tener un nombre único`,
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 4000,
          timerProgressBar: true,
        });
      }
      const response = await this.sendCreateRequestQuote(payload);
      if (!response || response.status == 500) {
        swal2.fire({
          icon: "error",
          title: "Error",
          text: "Ha ocurrido un error en el servidor, intentalo nuevamente",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 4000,
          timerProgressBar: true,
        });
      }
      if (
        response.response?.status == 400 ||
        response.response?.status == 404
      ) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: response?.response?.data?.detail,
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 4000,
          timerProgressBar: true,
        });
      }
      if (response.status == 200) {
        this.loading = false;
        this.resetFormCreateRequestQuote();
        let message =
          "Su solicitud de cotización ha sido creada correctamente, pronto será revisado por el equipo de compras";
        swal2.fire({
          icon: "success",
          title: "Excelente",
          text: message,
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 7000,
          timerProgressBar: true,
        });
        this.$emit("requestQuoteCreated");
      }
      this.loading = false;
      this.closeModalCreateRequestQuote(true);
    },
    addNewService() {
      this.currentServices.push({
        id:
          Math.random()
            .toString(36)
            .substring(2, 15) +
          Math.random()
            .toString(36)
            .substring(2, 15),
        quantity: 0,
        name: "",
        comment: null,
        documents: [],
      });
      this.currentServices.forEach(
        (item, index) => (item.key = `${item.id}-${index}`)
      );
    },
    openModalFilesService(item) {
      this.currentService = item;
      this.dialogModalFilesService = true;
    },
    closeModalFilesService($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        this.currentService = null;
        this.dialogModalFilesService = false;
      }
    },
    openModalUpdateCommentService(item) {
      this.currentService = item;
      this.dialogModalUpdateCommentService = true;
    },
    closeModalUpdateCommentService() {
      this.currentService = null;
      this.dialogModalUpdateCommentService = false;
    },
    deleteService(service) {
      let self = this;
      swal2
        .fire({
          icon: "error",
          title: `¿Deseas eliminar este servicio: ${service.name}`,
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonColor: "red",
          confirmButtonText: "Eliminar",
          cancelButtonText: `Cancelar`,
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            self.currentServices = self.currentServices.filter((item) => {
              return item.key !== service.key;
            });
            swal2.fire({
              icon: "success",
              title: "Excelente",
              text: "Servicio eliminado correctamente",
              position: "top-end",
              showConfirmButton: false,
              toast: true,
              timer: 6000,
              timerProgressBar: true,
            });
          }
        });
    },
    executeCloseModalCreateRequestQuote($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        this.filters.filter = "";
        this.closeModalCreateRequestQuote($event);
      }
    },
    resetFormCreateRequestQuote() {
      this.currentServices = [
        {
          id:
            Math.random()
              .toString(36)
              .substring(2, 15) +
            Math.random()
              .toString(36)
              .substring(2, 15),
          quantity: 0,
          name: "",
          comment: null,
          documents: [],
        },
      ];
    },
  },
  computed: {
    ...authUsuarioComputed,
    ...mapGetters({}),
    wrappedTableHeaders() {
      return [...this.tableHeaders];
    },
  },
  watch: {},
};
</script>

<style>
.my-swal-popup {
  z-index: 30000 !important;
}
</style>
